// Generated by CoffeeScript 2.7.0
var NormalVertexConfig;

import PhaseFieldsLogicModal from 'trunks/vue/admin/components/modals/phase_fields_logic_modal.js';

import RefuseCheckBox from 'trunks/vue/admin/components/modals/refuse_check_box.js';

import EditYawPushPackageModal from 'trunks/vue/admin/components/modals/yaw_push_package_modal/edit_yaw_push_package_modal.js';

import VertexConfig from './base.js';

export default NormalVertexConfig = Vue.extend({
  extends: VertexConfig,
  components: {
    'refuse-check-box': RefuseCheckBox
  },
  template: `<div class="config-container">
  <tabs navsClass='nav secondary config-nav'>
    <tab name='节点基础属性' tabKey='basic'>
      <div class="config-item">
        <div class="config-item-content">
          <div class="list settings-list">
            <div class="list-item">
              <div class="tip">节点名称</div>
              <div class="content">
                <input type="text" v-model.trim='vertex.name' placeholder='节点名称' />
              </div>
            </div>
            <div class="list-item">
              <div class="tip">节点别名</div>
              <div class="content">
                <input type="text" v-model.trim='vertex.alias_name' placeholder='节点别名' />
              </div>
            </div>
          </div>
        </div>
      </div>
      <user-boundary-comp :userBoundary='vertex.user_boundary'
                          title='处理者范围'
                          :extraBoundaryComps='userBoundaryCompOptions'
                          @valueChanged='userBoundaryChangeFunc' />
      <user-boundary-comp :userBoundary='vertex.cc_user_boundary'
                          title='抄送'
                          :extraBoundaryComps='ccUserBoundaryCompOptions'
                          @valueChanged='ccUserBoundaryChangeFunc' />
      <div class="config-item">
        <div class="config-item-title justify-box">
          <span class="content text-ellipsis">推送设置</span>
          <i class="slp-logic-edit" @click='openPushPackageSettingsModal'></i>
        </div>
        <div class="config-item-content">
          <div class="list">
            <div class="mt-2 mb-2 list-item push-box" v-for='(option, index) in vertex.push_settings'
                  :key='option.id'>
              <div class="justify-box content">
                <div class="light-gray-text push-box-order">{{ index + 1 }}</div>
                <div
                  v-html="\`\${renderPushItemText(option)}\`">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="config-item">
        <div class="config-item-title justify-box">
          <span class="content text-ellipsis">回传字段</span>
          <popover-field-select extendClass='field-select-popover'
                                :formatDataFunc='formatDataFunc'
                                :initialSelectedOptionIds='vertex.field_ids'
                                @submitClicked="updateVertexFields"
                                ref='fieldSelectRef'>
            <template slot='trigger'>
              <i class="slp-link-o"></i>
            </template>
            <template slot='option-item-template' slot-scope='{ option }'>
              <div class="content text-ellipsis">
                <i :class="_fieldIcon(option)"></i>
                <span>{{ option.name }}</span>
              </div>
              <i class="tip" :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
            </template>
            <div slot='filter-blankslate' class="list-group-name">没有能引用的回传字段</div>
            <div slot='options-blankslate' class="list-group-name">没有能引用的回传字段</div>
          </popover-field-select>
          <i :class="logicIcon" @click='openFieldsLogicModal'></i>
        </div>
        <div class="config-item-content">
          <div class="list-group" v-for='group in selectedFields'
               :key='group.id'>
            <div class="list-group-name">{{ group.name }}</div>
            <div class="list">
              <div class="list-item" v-for='option in group.options'
                   :key='option.id'>
                <div class="content text-ellipsis">
                  <i :class="_fieldIcon(option)"></i>
                  <span>{{ option.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab name='更多属性' tabKey='additional'>
      <div class="config-item">
        <div class="config-item-content">
          <div class="list settings-list">
            <operation-btn-switch v-for='(btn, key) in operationsButtons'
                                  :button='btn'
                                  :type='key'
                                  :key='key' />
            <div class="comment-settings-list" v-if="vertex.operations.comment.enabled">
              <label class="option-item">
                <input type="checkbox" v-model='vertex.settings.comment_present.approve' hidden='true'>
                <i class="slp-square-o"></i>
                <div class="option-label">通过时必填</div>
              </label>
              <label class="option-item">
                <input type="checkbox" v-model='vertex.settings.comment_present.refuse' hidden='true'>
                <i class="slp-square-o"></i>
                <div class="option-label">回退时必填</div>
              </label>
              <label class="option-item">
                <input type="checkbox" v-model='vertex.settings.comment_present.transfer' hidden='true'>
                <i class="slp-square-o"></i>
                <div class="option-label">转交时必填</div>
              </label>
            </div>
            <div class="list-item">
              <div class="tip">电子签字</div>
              <div class="content">
                <label class="small switch">
                  <input type="checkbox" hidden='true' v-model='vertex.operations.esignature.enabled' />
                  <span></span>
                </label>
              </div>
            </div>
            <div class="list-item">
              <div class="tip">手动抄送</div>
              <div class="content">
                <label class="switch small">
                  <input type="checkbox" hidden='true' v-model='vertex.settings.carbon_copy.enable_manual' />
                  <span></span>
                </label>
              </div>
            </div>
            <div class="list-item">
              <div class="tip">批量处理</div>
              <div class="content">
                <label class="switch small">
                  <input
                    type="checkbox"
                    hidden='true'
                    v-model='vertex.settings.batch_processing'
                  />
                  <span></span>
                </label>
              </div>
            </div>
            <div class="list-item">
              <div class="tip">处理人别名</div>
              <div class="content">
                <input type="text" v-model.trim='vertex.settings.processor_alias_name' placeholder='处理人别名' />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="config-item">
        <div class="config-item-title justify-box">
          <span class="content text-ellipsis">节点处理时限</span>
        </div>
        <div class="config-item-content">
          <div class="list settings-list">
            <div class="list-item">
              <div class="tip force-no-wrap">手动设置处理时限</div>
              <div class="content">
                <label class="small switch">
                  <input type="checkbox" hidden='true' v-model='vertex.settings.duration_threshold.enable_manual' />
                  <span></span>
                </label>
              </div>
            </div>
            <div class="list-item">
              <div class="tip force-no-wrap">时长限制</div>
              <time-span customClass='content'
                        :duration='duration'
                        ref='timespanRef'
                        @valueChanged='updateDurationThresholdFunc' />
            </div>
            <div class="list-item" v-if='!vertex.isInitial'>
              <div class="tip">申请延时</div>
              <div class="content">
                <label class="small switch">
                  <input type="checkbox" hidden='true' v-model='vertex.settings.duration_threshold.enable_delay' />
                  <span></span>
                </label>
              </div>
            </div>
            <div class="list-item business-time-setting">
              <span class="tip text-ellipsis">工作时间</span>
              <label class="content switch small">
                <input type="checkbox" hidden='true'
                      :checked='business_time_enabled'
                      @change='toggleBusinessTimeEnabled'>
                  <span></span>
              </label>
            </div>
            <business-time-comp v-show='business_time_enabled'
                                :initValue='business_time'
                                ref='businessTimeRef'
                                @valueChanged='updateBusinessTimeFunc' />
          </div>
        </div>
      </div>
      <div class="config-item">
        <div class="config-item-title">操作者按钮</div>
        <div class="config-item-content">
          <div class="list operations-list">
            <operation-btn-checkbox :button='vertex.operations.approve'
                                    type='approve' />
            <label class="option-item">
              <input type="checkbox" :checked="initialSettingsAssignManual" @change='setAssignManually' hidden='true'>
              <i class="slp-square-o"></i>
              <div class="option-label">手动选择下一个处理者</div>
            </label>
            <div class="list-item" v-if="vertex.settings.assign_manually">
              <div class="tip">
                <div class="option-item">
                  <i class="slp-empty"></i>
                  <div class="option-label">方式</div>
                </div>
              </div>
              <div class="content">
                <dropdown-select :optionGroups="[{ options: allowedApproveValue }]"
                                customClass='transparent'
                                :initValue='vertex.settings.assign_manually'
                                @change='approveValueChangeFunc'>
                  <template slot='value-template' slot-scope='{ option }'>
                    <span>{{ Skylark.Helpers.getZH_CN('assignment.approve.' + option) }}</span>
                  </template>
                  <template slot='option-template' slot-scope='{ option }'>
                    <span>{{ Skylark.Helpers.getZH_CN('assignment.approve.' + option) }}</span>
                  </template>
                </dropdown-select>
              </div>
            </div>
            <label class="option-item">
              <input type="checkbox" v-model='vertex.settings.distributed_equally' hidden='true'>
              <i class="slp-square-o"></i>
              <div class="option-label">平均分配下一个处理者</div>
            </label>
            <operation-btn-checkbox :button='vertex.operations.refuse'
                                    type='refuse' />
            <refuse-check-box :refuseMode="vertex.settings.refuse_mode"
                              :refuseReviewersMode="vertex.settings.refuse_reviewers_mode"
                              @refuseModeChanged="refuseModeChangedFunc"
                              @refuseReviewersModeChanged="refuseReviewesModeChangedFunc"/>
            <operation-btn-checkbox :button='vertex.operations.transfer'
                                    type='transfer' />
          </div>
        </div>
      </div>
    </tab>
  </tabs>
</div>`,
  data: function() {
    return {
      phaseFieldsLogicModal: null
    };
  },
  computed: {
    operationsButtons: function() {
      return _.pick(this.vertex.operations, 'comment');
    },
    user_boundary_comp_options: function() {
      var options;
      options = [];
      options.push({
        name: 'dynamic-reviewer',
        previousVerticesUrl: this.vertex.getPreviousVerticesUrl()
      });
      return options;
    },
    logicIcon: function() {
      if (_.isEmpty(this.vertex.logic_settings)) {
        return 'slp-logic-add';
      } else {
        return 'slp-logic-edit';
      }
    }
  },
  watch: {
    'vertex.settings.assign_manually': function() {
      if (this.vertex.settings.assign_manually) {
        return this.vertex.settings.distributed_equally = !this.vertex.settings.assign_manually;
      }
    },
    'vertex.settings.distributed_equally': function() {
      if (this.vertex.settings.distributed_equally) {
        return this.vertex.settings.assign_manually = !this.vertex.settings.distributed_equally;
      }
    }
  },
  methods: {
    openFieldsLogicModal: function() {
      var vertex;
      vertex = {
        ...this.vertex,
        fields: this.getFields()
      };
      this.phaseFieldsLogicModal = new PhaseFieldsLogicModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('phase_fields_logic_modal_container'),
        propsData: {
          vertex: vertex
        }
      });
      return this.phaseFieldsLogicModal.$on('ensureClicked', (logic_settings) => {
        this.vertex.logic_settings = {
          constraints: logic_settings
        };
        return this.updateVertex();
      });
    },
    getFields: function() {
      var field_ids, fields, graphs;
      ({field_ids} = this.vertex);
      graphs = graphs || this.vertex.graph.getAncestors().concat(this.vertex.graph);
      fields = _.reduce(graphs, function(acc, graph) {
        _.each(graph.getOwnFields(), function(field) {
          return acc.push(field);
        });
        return acc;
      }, []);
      return _.filter(fields, function(field) {
        return field_ids.includes(field.id);
      });
    },
    refuseModeChangedFunc: function(val) {
      return this.vertex.settings.refuse_mode = val;
    },
    refuseReviewesModeChangedFunc: function(val) {
      return this.vertex.settings = {
        ...this.vertex.settings,
        refuse_reviewers_mode: val
      };
    },
    openPushPackageSettingsModal: function() {
      this.editYawPushPackageModal = new EditYawPushPackageModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('yaw_push_package_modal_container'),
        propsData: {
          vertex: this.vertex
        }
      });
      return this.editYawPushPackageModal.$on('ensureClicked', (pushPackage) => {
        this.vertex.push_settings = pushPackage;
        return this.updateVertex();
      });
    },
    renderPushItemText: function(option) {
      var scope;
      scope = option.push_type === 'Push::Webhook' ? '' : Skylark.Helpers.translate(`yaw_vertex.push.scope.${option.push_scope}`);
      return `${Skylark.Helpers.translate(`yaw_vertex.push.time.${option.push_time}`)}${option.waiting}分钟<span class='push-box-type'> ${Skylark.Helpers.translate(`yaw_vertex.push.type.${option.push_type}`)} </span>推送${scope}`;
    }
  }
});
